// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"mapfees_errorMessage__1Tron","Title":"mapfees_Title__2b0oi"};